(function () {
  if (window.__vacHomeInit) return;
  window.__vacHomeInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SELECTOR = [
    '.vac .vac-hero__media', '.vac .vac-hero__copy', '.vac .vac__head',
    '.vac-card', '.vac-review', '.vac-subject', '.vac-about',
    '.vac-pv__inner > *', '.vac-tiles-wrap .vac__h2', '.vac-tile',
    '.vac-post', '.vac-trust__item'
  ].join(',');

  function setup(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains('vac-rv')) return;
      var parent = el.parentElement;
      var index = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
      el.style.setProperty('--vac-d', Math.min(index, 6) * 90 + 'ms');
      el.classList.add('vac-rv');
      io.observe(el);
    });
  }

  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', function () { setup(); });

  document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
})();
